import React from 'react';

import { useGetInstallsQuery } from 'src/services/api/applicationsApi';

type ChangeableModulesIds =
  | 'payments'
  | 'knowledgeBase'
  | 'messages'
  | 'files'
  | 'forms'
  | 'contracts';
export const usePageTitle = (
  defaultTitle: string,
  moduleId: ChangeableModulesIds,
) => {
  const { data: { moduleSettings } = {}, isLoading } = useGetInstallsQuery();

  const { pageTitle, icon } = React.useMemo(() => {
    if (!moduleSettings || moduleSettings.length === 0) {
      return { pageTitle: defaultTitle, icon: undefined };
    }
    const pageModule = moduleSettings.find((module) => module.id === moduleId);
    if (!pageModule) {
      return { pageTitle: defaultTitle, icon: undefined };
    }
    return { pageTitle: pageModule.label, icon: pageModule.icon };
  }, [moduleSettings, defaultTitle, moduleId]);

  return { pageTitle, icon, isLoading };
};
